import GridModule from './grid.js';

export default {
  __init__: [ 'grid' ],
  grid: [ 'type', GridModule ]
};